import React from "react";
import { Link } from "react-router-dom";
import { MdDiamond, MdHouse, MdMail, MdPhone } from "react-icons/md";
import { languageHelper } from "../../config/helperFunctions";

function Footer({ logo }) {
  
  return (
    <footer className="bg-white shadow-[rgba(0,0,15,0.5)_10px_5px_4px_4px]">
      <div className="px-4 pt-4 pb-24 lg:px-6 lg:py-16 mx-auto max-w-screen-xl">
        <div className="flex justify-center lg:justify-between gap-x-8 gap-y-4 flex-wrap">
          <div className="mb-6 md:mb-0">
            <span className="text-lg flex items-center gap-4 text-gray-500">
              <MdDiamond /> {languageHelper("imdady") || "Imdady"}
            </span>
            <Link to={"/"} className="my-8">
              <img src={logo} className="w-32" alt="FlowBite Logo" />
            </Link>
            <div className="flex gap-2 items-center my-6">
              <a href="/">
                <img
                  src="/assets/logo/Google_play_button.svg"
                  className="w-32"
                  alt=""
                />
              </a>
              <a href="/">
                <img
                  src="/assets/logo/Apple_store_button.png"
                  className="w-32"
                  alt=""
                />
              </a>
            </div>
            {/* <p className="mt-8 text-sm">© 2024 Imdady . All rights reserved</p> */}
          </div>
          <div className="text-gray-500">
            <h2 className="mb-6 text-lg uppercase">
              {languageHelper("contact") || "Contact"}
            </h2>
            <ul>
              <li className="mb-4">
                <a href="/" className="hover:underline flex gap-4 items-center">
                  <MdHouse /> Riyadh
                </a>
              </li>
              <li className="mb-4">
                <a href="/" className="hover:underline flex gap-4 items-center">
                  <MdMail /> info@imdady.com
                </a>
              </li>
              <li className="mb-4">
                <a href="/" className="hover:underline flex gap-4 items-center">
                  <MdPhone /> 966535090666
                </a>
              </li>
            </ul>
          </div>
          <div className="text-gray-500">
            <h2 className="mb-6 text-lg uppercase">
              {languageHelper("follow us") || "Follow Us"}
            </h2>
            <ul className="flex gap-2 items-center">
              <li className="mb-4">
                <a href="/" className="hover:underline ">
                  <img src="/assets/admin/fb.png" alt="" />
                </a>
              </li>
              <li className="mb-4">
                <a href="/" className="hover:underline">
                  <img src="/assets/admin/tw.png" alt="" />
                </a>
              </li>
              <li className="mb-4">
                <a href="/" className="hover:underline">
                  <img src="/assets/admin/in.png" alt="" />
                </a>
              </li>
              <li className="mb-4">
                <a href="/" className="hover:underline">
                  <img src="/assets/admin/li.png" alt="" />
                </a>
              </li>
            </ul>
          </div>
          <div className="text-gray-500">
            <h2 className="mb-6 text-lg uppercase">
              {languageHelper("our timings") || "Our Timings"}
            </h2>
            <ul>
              <li className="mb-4">
                <a href="/" className="hover:underline">
                  Sunday - Saturday
                </a>
              </li>
              <li className="mb-4">
                <a href="/" className="hover:underline">
                  11:30 AM - 12:30 AM
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="text-lg text-white text-center bg-w-bg py-4 mb-20 md:mb-0">
        <p>
          {languageHelper("© 2024 Copyright: Imdady.com") ||
            "© 2024 Copyright:"}{" "}
          <a
            href="https://www.imdady.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Imdady.com
          </a>{" "}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
